var chunkToChildrenMap = {
	"74794": [
		48890,
		60699
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };